import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import {
	Client,
	EstablecimientoExtendedDto,
	EstablecimientoOptionDto,
	EnumDtoOfMunicipio,
	EnumDtoOfGerenciaAreaSalud,
	Provincia,
	RegionSalud,
	EstablecimientoDto
} from '../../shared/services/client';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { errorMessages } from '../../../../src/assets/constants.json';

enum ModalAction {
	Create = 1,
	Edit = 2,
}

@Component({
	selector: 'app-establecimientos',
	templateUrl: './establecimientos.component.html',
	styleUrls: ['./establecimientos.component.scss']
})
export class EstablecimientosComponent implements OnInit {
	@ViewChild('editModal') editModal: any;
	@ViewChild('confirmModal') confirmModal: any;
	@ViewChild('deleteConfirmModal') deleteConfirmModal: any;

	columns = [
		{ propertyName: 'regionSalud', displayName: 'Región' },
		{ propertyName: 'nombreEstablecimiento', displayName: 'Nombre' },
		{ propertyName: 'nivelAtencion', displayName: 'Nivel de Atención' },
		{ propertyName: 'localidad', displayName: 'Localidad' },
		{ class: 'text-pre-line', propertyName: 'metaMensual', displayName: 'Meta\nMensual' },
		{ class: 'text-pre-line', propertyName: 'entregas', displayName: 'Entregas\ndel Mes' },
		{ class: 'text-pre-line', propertyName: 'progreso', displayName: 'Progreso\ndel Mes' },
		{ propertyName: 'centroSuspendido', displayName: 'Estado' }
	];
	sortOrder: any = { regionSalud: 'ASC' };

	ModalAction = ModalAction;
	modalAction: ModalAction;

	currentPage = 1;
	pageSize = 10;
	length = 0;

	establecimientos: EstablecimientoExtendedDto[] = [];
	filterOptions: any = null;
	filters: string;
	currentEntity: EstablecimientoDto;
	establecimientosForm: FormGroup;
	opciones: EstablecimientoOptionDto;
	municipios: EnumDtoOfMunicipio[] = [];
	gerenciasAreaSalud: EnumDtoOfGerenciaAreaSalud[] = [];

	confirmModalTitle: string;
	confirmModalMessage: string;
	confirmModalAction: string;

	@Input() enableAdminFunctions = false;

	constructor(
		public router: Router,
		public client: Client,
		private spinner: NgxSpinnerService,
		private alertService: AlertService,
		public fb: FormBuilder,
		private modalService: NgbModal
	) {
		this.client.establecimientos_GetEstablecimientosOptions()
			.subscribe((result) => {
				this.opciones = result;
			}, (error) => {
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});

		this.changePage();
	}

	ngOnInit() {
		this.establecimientosForm = this.fb.group({
			nombreEstablecimiento: ['', [Validators.required, Validators.maxLength(100)]],
			nivelAtencion: ['', [Validators.required, Validators.maxLength(100)]],
			complejidadServicio: ['', [Validators.required, Validators.maxLength(100)]],
			tipoCentro: ['', [Validators.required, Validators.maxLength(100)]],
			administradoPor: ['', [Validators.required, Validators.maxLength(100)]],
			regionSalud: ['', [Validators.required, Validators.maxLength(100)]],
			gerenciaAreaSalud: ['', [Validators.required, Validators.maxLength(100)]],
			provincia: [{}, Validators.maxLength(100)],
			municipio: ['', [Validators.required, Validators.maxLength(100)]],
			metaMensual: [0]
		});
	}

	filterEstablecimientos(filterOptions: any) {
		this.filters = JSON.stringify({
			nivelAtencion: filterOptions.nivelAtencion,
			regionSalud: filterOptions.regionSalud,
			fecha: filterOptions.fecha,
			provincia: filterOptions.provincia,
			nombreEstablecimiento: filterOptions.nombreEstablecimiento
		});
		this.changePage();
	}

	private getSortOrder(): string | undefined {
		if (Object.keys(this.sortOrder).length === 0) {
			return undefined;
		} else {
			return JSON.stringify({
				regionSalud: this.sortOrder.regionSalud,
				nombreEstablecimiento: this.sortOrder.nombreEstablecimiento,
				nivelAtencion: this.sortOrder.nivelAtencion,
				localidad: this.sortOrder.localidad,
				entregas: this.sortOrder.entregas,
				metaMensual: this.sortOrder.metaMensual,
				progreso: this.sortOrder.progreso,
				centroSuspendido: this.sortOrder.centroSuspendido
			});
		}
	}

	setColumnSortOrder(columnName: string) {
		const columnSortOrder = this.sortOrder[columnName];
		this.sortOrder = {};
		if (!columnSortOrder) {
			this.sortOrder[columnName] = 'ASC';
		} else if (columnSortOrder === 'ASC') {
			this.sortOrder[columnName] = 'DESC';
		} else if (columnSortOrder === 'DESC') {
			this.sortOrder[columnName] = undefined;
		}
		this.changePage();
	}

	changePage($event?: PageEvent) {
		if (!!$event) {
			this.currentPage = $event.pageIndex + 1;
			this.pageSize = $event.pageSize;
		}
		const sortOrder = this.getSortOrder();
		this.spinner.show();
		this.client.establecimientos_GetEstablecimientos(this.currentPage, this.pageSize, this.filters, sortOrder)
			.finally(() => this.spinner.hide())
			.subscribe((result) => {
				this.establecimientos = result.results;
				this.length = result.rowCount;
			}, (error) => {
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}

	onSelectedEstablecimiento(establecimiento: EstablecimientoDto) {
		return this.router.navigate(
			['admin/entregas/lista'],
			{
				queryParams: {
					establecimientoId: establecimiento.id,
					nombreEstablecimiento: establecimiento.nombreEstablecimiento
				}
			});
	}

	openCreateModal() {
		this.modalAction = ModalAction.Create;
		this.currentEntity = null;

		// Set form values
		this.establecimientosForm.setValue({
			nombreEstablecimiento: null,
			nivelAtencion: null,
			complejidadServicio: null,
			tipoCentro: null,
			administradoPor: null,
			regionSalud: null,
			gerenciaAreaSalud: null,
			provincia: null,
			municipio: null,
			metaMensual: null
		});

		this.provinciaSelected(undefined);
		this.regionSaludSelected(undefined);

		// Open edit modal
		this.modalService.open(this.editModal, { centered: true, size: 'lg' });
	}

	openEditModal(establecimiento: EstablecimientoDto) {
		this.modalAction = ModalAction.Edit;
		this.currentEntity = establecimiento;
		this.establecimientosForm.setValue({
			nombreEstablecimiento: establecimiento.nombreEstablecimiento,
			nivelAtencion: establecimiento.nivelAtencion,
			complejidadServicio: establecimiento.complejidadServicio,
			tipoCentro: establecimiento.tipoCentro,
			administradoPor: establecimiento.administradoPor,
			regionSalud: establecimiento.regionSalud,
			gerenciaAreaSalud: establecimiento.gerenciaAreaSalud,
			provincia: establecimiento.provincia,
			municipio: establecimiento.municipio,
			metaMensual: establecimiento.metaMensual
		});
		this.provinciaSelected(establecimiento.provincia);
		this.regionSaludSelected(establecimiento.regionSalud);
		this.modalService.open(this.editModal, { centered: true, size: 'lg' });
	}

	onSubmit() {
		this.spinner.show();
		const establecimiento: EstablecimientoDto = { ...this.currentEntity, ...this.establecimientosForm.value };
		if (this.modalAction === ModalAction.Edit) {
			this.client.establecimientos_PutEstablecimiento(this.currentEntity.id, establecimiento)
				.finally(() => {
					this.spinner.hide();
					this.modalService.dismissAll();
				})
				.subscribe(() => {
					this.alertService.success('El establecimiento se ha guardado exitosamente.');
					this.changePage();
				}, (error) => {
					const errorMessage = error.status === 0 ?
						errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
					this.alertService.danger(errorMessage);
				});
		} else {
			this.client.establecimientos_PostEstablecimiento(establecimiento)
				.finally(() => {
					this.spinner.hide();
					this.modalService.dismissAll();
				})
				.subscribe(() => {
					this.alertService.success('El establecimiento ha sido creado exitosamente.');
					this.changePage();
				}, (error) => {
					const errorMessage = error.status === 0 ?
						errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
					this.alertService.danger(errorMessage);
				});
		}
	}

	provinciaSelected(provincia: Provincia | undefined) {
		const provincias = this.opciones.provincia;
		this.municipios = !!provincia ? provincias.find(x => x.value === parseInt(provincia.toString(), 10)).municipio : [];
	}

	regionSaludSelected(regionSalud: RegionSalud | undefined) {
		const regiones = this.opciones.regionSalud;
		this.gerenciasAreaSalud = !!regionSalud ? regiones.find(x => x.value === parseInt(regionSalud.toString(), 10)).gerenciaAreaSalud : [];
	}

	onDeleteEstablecimiento(establecimiento: EstablecimientoDto) {
		this.currentEntity = establecimiento;
		this.modalService.open(this.deleteConfirmModal, { centered: true });
	}

	onConfirmDelete() {
		this.spinner.show();
		const establecimientoId = this.currentEntity.id;
		this.client.establecimientos_DeleteEstablecimiento(establecimientoId)
			.finally(() => {
				this.modalService.dismissAll();
				this.spinner.hide();
			})
			.subscribe(() => {
				this.alertService.success('El establecimiento ha sido eliminado exitosamente.');
				this.changePage();
			}, (error) => {
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}

	openConfirmationModal(establecimiento: EstablecimientoDto) {
		this.currentEntity = establecimiento;
		this.confirmModalAction = !establecimiento.centroSuspendido ? 'Deshabilitar' : 'Habilitar';
		this.confirmModalTitle = `${this.confirmModalAction} Establecimiento`;
		this.confirmModalMessage = `¿Seguro que desea ${this.confirmModalAction.toLowerCase()} este establecimiento?`;
		this.modalService.open(this.confirmModal, { centered: true });
	}

	private toggleEstablecimientoState() {
		this.spinner.show();
		this.currentEntity.centroSuspendido = !this.currentEntity.centroSuspendido;
		const establecimientoDto: any = { ...this.currentEntity };
		this.client.establecimientos_PatchEstablecimiento(establecimientoDto.id, establecimientoDto)
			.finally(() => {
				this.spinner.hide();
				this.modalService.dismissAll();
			})
			.subscribe(() => {
				this.alertService.success(`Establecimiento ${this.currentEntity.centroSuspendido ? 'deshabilitado' : 'habilitado'} exitosamente.`);
				this.changePage();
			}, (error) => {
				this.currentEntity.centroSuspendido = !this.currentEntity.centroSuspendido;
				const errorMessage = error.status === 0 ?
					errorMessages.connectionError : !!error.title ? error.title : errorMessages.genericError;
				this.alertService.danger(errorMessage);
			});
	}
}
